import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { getClassName } from '../../../utils'

/**
 * ToolbarRow Component
 */
class ToolbarRow extends PureComponent {
  /**
   * Render ToolbarRow component
   * @return {XML}
   */
  render () {
    const { className, justified, children } = this.props

    const baseClassName = getClassName('toolbar_row', [
      { condition: className, trueClassName: className },
      { condition: justified, trueClassName: 'toolbar_row--justified' }
    ])

    return (
      <div className={baseClassName}>{children}</div>
    )
  }
}

ToolbarRow.propTypes = {
  className: PropTypes.string,
  justified: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
}

export default ToolbarRow
